//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";

const ldapGenericAvatar = "@/assets/images/LDAP-user-generic-avatar.svg";

export default {
    name: "MembersListInfo",
    components: {
        AQChip
    },
    props: {
        membersList: {
            type: Array,
            default: () => []
        },
        showAll: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    methods: {
        getChipProps(member) {
            const { sourceType, type, userId, groupId, name, firstName, lastName, email, status } = member;

            let typeToReturn = "";
            if (type === "dataModels") {
                typeToReturn = "m_datamodel";
            } else if ((type === "USER" && sourceType !== "AD") || type === "users" || userId) {
                typeToReturn = status === "DISABLED" ? "disabledUser" : "user";
            } else if ((type === "GROUP" && sourceType !== "AD") || type === "groups" || groupId) {
                typeToReturn = "group";
            }

            let iconToShow = {};
            if (sourceType === "AD" && type === "GROUP") {
                iconToShow = {
                    name: "business",
                    color: "var(--q-color-external-task)",
                    size: "16px"
                };
            } else if (type === "USER" && sourceType === "AD") {
                iconToShow = {
                    path: ldapGenericAvatar,
                    size: "16px"
                };
            }

            let contentToShow = "";
            if (groupId) {
                contentToShow = name;
            } else if (userId) {
                if (firstName || lastName) {
                    contentToShow = firstName && lastName ? `${firstName} ${lastName}`.trim() : (firstName || lastName);
                } else {
                    contentToShow = email;
                }
            } else {
                contentToShow = name || "Null";
            }
            return {
                iconLeft: iconToShow,
                type: typeToReturn,
                content: contentToShow
            };
        }
    }
};
